module.exports = __webpack_public_path__ + "img/kid11.bb0443bb.png";